import { SelectedMenu } from 'rangeConfig/@types';
import deleteSelectedEntity from 'rangeConfig/shared/behaviors/deleteSelectedEntity';
import replaceProduct from 'rangeConfig/shared/behaviors/replaceProduct';
import { matchType } from 'rangeConfig/shared/filters/selectedMenuProductFilters';
import platform from 'rangeConfig/shared/utils/platform';
import DimensionsLabel from 'rangeConfig/shared/widgets/DimensionsLabel';

const widgets = {
  desktop: [
    {
      id: 'display-size',
      title: 'storageone.sizeFilterLabel',
      component: DimensionsLabel
    },
    {
      id: 'appliances-selected-menu',
      title: 'storageone.appliances',
      cardsSubtitle: 'typeName, designText, communicatedSizeText',
      filters: [],
      behaviors: {
        productClicked: [replaceProduct],
        productDropped: [replaceProduct]
      },
      productTypes: [],
      productFilters: [matchType]
    }
  ],
  mobile: []
};

const selectedMenu: SelectedMenu = {
  menuTitle: 'storageone.appliances',
  behaviors: {
    productDeleted: [deleteSelectedEntity]
  },
  content: widgets[platform]
};

export default selectedMenu;
